export default "__VITE_ASSET__CwxqCz8j__"